import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';

export class ReloadPage extends React.Component {
    public render() {
        return <Route
            render={({staticContext, history}) => {
                if (staticContext) {
                    staticContext.statusCode = 302;
                }
                const params = new URLSearchParams(history.location.search);
                const attempt = parseInt(params.get('t') || '', 10) || 0;
                if (attempt > 5) {
                    return null;
                }
                params.set('t', (attempt + 1).toString());
                return <Redirect to={`${history.location.pathname}?${params.toString()}`} />;
            }}
            />;
    }
}


// WEBPACK FOOTER //
// ./src/components/ReloadPage/ReloadPage.tsx